import { useEffect } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../services/hooks/useReduxHooks";
import { resetLoadingStackAndPendingOperations } from "../../../services/redux/slices/globalComponentsToggleSlice";
import { alert } from "../../../utils/APICalls/APICalls";
import { AlertErrorType } from "../../../utils/ErrorTypes";
import { LoadingDotBars } from "./LoadingDotBars";

export const NewLoading = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(
    (state) => state.globalComponentsToggleSlice.loading
  );

  const changingRestaurant = useAppSelector(
    (state) => state.globalComponentsToggleSlice.changingRestaurant
  );

  const loadingOperations = useAppSelector(
    (state) => state.globalComponentsToggleSlice.pendingOperations
  );
  const loadingStack = useAppSelector(
    (state) => state.globalComponentsToggleSlice.loadingStack
  );
  const restaurantConfig = useAppSelector(
    (state) => state.config.restaurantInfo
  )?.config;

  const orderDataLoading = useAppSelector(
    (state) => state.globalComponentsToggleSlice.orderDataLoading
  );

  const isLoading = restaurantConfig?.loadingStateSolution
    ? loadingOperations > 0
    : loading;

  // const isLoading = true;

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;
    if (!restaurantConfig?.loadingStateSolution) {
      return;
    }
    if (isLoading && restaurantConfig?.loadingStateSolution) {
      timeout = setTimeout(() => {
        alert(
          `${AlertErrorType.Loading_State_exceeded_10_seconds}`,
          loadingStack
        );
        dispatch(resetLoadingStackAndPendingOperations());
      }, 10000);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [isLoading]);

  return (
    <>
      {(isLoading || changingRestaurant || orderDataLoading) && (
        <LoadingDotBars />
      )}
    </>
  );
};
